import React from "react";
import { IconProps } from "./types";

export default function CopyIcon({
  width = 24,
  height = 24,
  className = "",
}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
    >
      <g clip-path="url(#clip0_58763_1198)">
        <path
          d="M9.33342 0.686523H2.33341C1.69175 0.686523 1.16675 1.21152 1.16675 1.85319V10.0199H2.33341V1.85319H9.33342V0.686523ZM8.75008 3.01986H4.66675C4.02508 3.01986 3.50592 3.54486 3.50592 4.18652L3.50008 12.3532C3.50008 12.9949 4.01925 13.5199 4.66091 13.5199H11.0834C11.7251 13.5199 12.2501 12.9949 12.2501 12.3532V6.51986L8.75008 3.01986ZM4.66675 12.3532V4.18652H8.16675V7.10319H11.0834V12.3532H4.66675Z"
          fill="#A8ADB5"
        />
      </g>
      <defs>
        <clipPath id="clip0_58763_1198">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(0 0.103516)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
